export const isPlainObject = (v) => {
    if (v == null)
        return false;
    if (typeof v !== 'object')
        return false;
    const proto = Object.getPrototypeOf(v);
    if (proto === null)
        return true;
    if (proto === Object.prototype)
        return true;
    return false;
};
//# sourceMappingURL=object.js.map